import { Button as MUIButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useThemeMode } from '../../../theme'

const getThemeSx = (palette) => ({
  '&.MuiButton-filled, &.MuiButton-contained': {
    borderRadius: '25px',
    background: palette.headerColor,
    color: palette.paperColor,
    '&:hover': { background: palette.headerColor }
  },
  '&.MuiButton-invert-contained': {
    borderRadius: '25px',
    background: palette.paperColor,
    color: palette.headerColor,
    fontWeight: 600,
    boxShadow: 'none',
    '&:hover': { background: palette.paperColor }
  }
})

export const Button = (props) => {
  const { icon, label, text, children } = props
  const { palette } = useThemeMode()
  const translation = useTranslation()
  const { t } = translation.i18n
  let translatedText = text ? t(text) : undefined
  translatedText = label ? t(label) : translatedText
  translatedText = translatedText ?? t(children)
  const variant = props.variant ?? 'filled'
  const themeSX = getThemeSx(palette)

  const sx = {
    ...themeSX,
    ...props.sx
  }

  const customProps = {
    ...props,
    variant,
    sx
  }
  return (
    <MUIButton {...customProps}>
      {icon}
      {translatedText}
    </MUIButton>
  )
}
